import { Directive, ElementRef, EventEmitter, HostListener, Input, NgZone, Output, Renderer2 } from '@angular/core';
import { fromEvent } from 'rxjs';

import { PreventDefault, StopPropagation } from '../../util';
import { FileDropClass } from '../models';
import { onlyFiles } from '../utils/only-files';
import { fileTypeAllowed } from '../validators';
import { BaseFileUploadDirective } from './base-file-upload.directive';

@Directive({
  selector: '[pcsFileDrop]'
})
export class FileDropDirective extends BaseFileUploadDirective {
  @Input() icon: string;
  @Output() fileDropped = new EventEmitter<File>();

  get hostElement(): HTMLElement {
    return this.hostElementRef.nativeElement;
  }

  constructor(private hostElementRef: ElementRef, private renderer: Renderer2, private ngZone: NgZone) {
    super();
    this.ngZone.runOutsideAngular(() => {
      fromEvent(this.hostElement, 'dragover').subscribe((event: DragEvent) => {
        this.onDragOver(event);
      });
    });
  }

  @PreventDefault()
  @StopPropagation()
  onDragOver(event: DragEvent) {
  }

  @HostListener('dragenter', ['$event'])
  @PreventDefault()
  @StopPropagation()
  onDragEnter(event: DragEvent) {
    this.addClass(FileDropClass.DragOver);
    if (!this.dataTransportAllowed(event.dataTransfer)) {
      this.addClass(FileDropClass.DropNotAllowed);
    }
  }

  @HostListener('dragleave', ['$event'])
  @PreventDefault()
  @StopPropagation()
  onDragLeave(event: DragEvent) {
    this.removeDragClasses();
  }

  @HostListener('drop', ['$event'])
  @PreventDefault()
  @StopPropagation()
  onDrop(event: DragEvent) {
    const files = event.dataTransfer.files;
    if (this.fileAllowed(files)) {
      this.handleFileDropped(files);
    }
    this.removeDragClasses();
  }

  private handleFileDropped(files: FileList) {
    this.fileDropped.emit(this.selectedFile(files));
  }

  private dataTransportAllowed({types, items}: Partial<DataTransfer>): boolean {
    return !this.disabled
      && onlyFiles(types)
      && fileTypeAllowed(items[0] as any, this.accepts);
  }

  private removeDragClasses() {
    this.removeClass(FileDropClass.DragOver);
    this.removeClass(FileDropClass.DropNotAllowed);
  }

  private addClass(className: string) {
    this.renderer.addClass(this.hostElement, className);
  }

  private removeClass(className: string) {
    this.renderer.removeClass(this.hostElement, className);
  }
}
